<template>
    <div>
      <div class="policy notifCont">
        <div v-if="vehicleType">
          <b-tooltip multilined type="is-light" :position="position">
            <!-- Show Electric Vehicle tag -->
            <b-tag
              v-if="vehicleType === 'Electric'"
              type="is-info"
              class="is-small"
            >
              <b-icon icon="flash" size="is-small"></b-icon>
              <span>Electric Vehicle</span>
            </b-tag>
  
            <!-- Show Hybrid Vehicle tag -->
            <b-tag
              v-if="vehicleType === 'Hybrid'"
              type="is-info"
              class="is-small"
            >
              <b-icon icon="battery-charging-50" size="is-small"></b-icon>
              <span>Hybrid Vehicle</span>
            </b-tag>
  
            <!-- Show Plug-in Hybrid Vehicle tag -->
            <b-tag
              v-if="vehicleType === 'Plug-in hybrid'"
              type="is-info"
              class="is-small"
            >
              <b-icon icon="power-plug-outline" size="is-small"></b-icon>
              <span>Plug-in Hybrid Vehicle</span>
            </b-tag>
  
            <template v-slot:content>
              <h5 class="is-size-7 has-text-weight-bold has-text-left mb-1">
                This vehicle is a
                {{ vehicleType === 'Electric' ? 'Electric Vehicle' :
                  vehicleType === 'Plug-in hybrid' ? 'Plug-in Hybrid Vehicle' : 
                  'Hybrid Vehicle' }}
              </h5>
            </template>
          </b-tooltip>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    name: "VehicleTypeTag",
    props: {
      vehicleType: {
        type: String,  // Expecting 'Electric', 'Hybrid', or 'Plug-in hybrid'
        required: true,
      },
      position: {
        type: String,
        default: "is-bottom",
      },
    },
  };
  </script>
  
  <style scoped></style>
  